'use strict';

import axios from 'axios'
// import qs from 'qs' //qs组件来避开ajax信使请求，并兼容Android。
import Vue from 'vue'
import VueRouter from "vue-router";
import router from '../router/index.js'
// let Base64 = require('js-base64').Base64;
const routes = new VueRouter({
	router
});
let vm = new Vue({
	routes
});

/**
 * http请求拦截器
 */
axios.interceptors.request.use(config => {
	//设置请求头信息
	// let token = localStorage.getItem('token') || '';
	// const headersOption = {
	// 	token,
	// };
	// config.headers = Object.assign(config.headers, headersOption);
	return config;
}, error => {
	return Promise.reject(error)
});

axios.interceptors.response.use(response => {
	return response
}, error => {
	return Promise.reject(error)
});

function checkStatus(response) {
	if (response.data.status && response.status == 200) {
		return response;
	}else if(Array.isArray(response.data)){
		return response;
	}else{
    // this.$message.error(response.data.message)
		return response;
	}
}

function checkCode(res) {
	return res
}

export default {
	newpost(url, data,heads) {
		return axios({
			method: 'post',
			baseURL: '/',
			url,
			data: data,
			timeout: 100000,
			headers: heads,
		}).then(
			(response) => {
				return checkStatus(response)
			}
		).then(
			(res) => {
				return checkCode(res)
			}
		)
	},
	post(url, data) {
		return axios({
			method: 'post',
			baseURL: '/',
			url,
			data: data,
			timeout: 100000,
			headers: {
			    'X-Requested-With': 'XMLHttpRequest',
			    "Content-Type": "application/json",
			},
		}).then(
			(response) => {
				return checkStatus(response)
			}
		).then(
			(res) => {
				return checkCode(res)
			}
		)
	},
	posttoken(url, data) {
		return axios({
			method: 'post',
			baseURL: '/',
			url,
			data: data,
			timeout: 100000,
			headers: {
				'X-Requested-With': 'XMLHttpRequest',
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
			},
		}).then(
			(response) => {
				return checkStatus(response)
			}
		).then(
			(res) => {
				return checkCode(res)
			}
		)
	},
	postImage(url, data) {
		return axios({
			method: 'post',
			baseURL: process.env.NODE_ENV=='development'?'/api':'/',
			url,
			data: data,
			timeout: 100000,
			headers: {
			    'X-Requested-With': 'XMLHttpRequest',
				"Content-Type": "application/json",
			},
			responseType: 'blob',
		}).then(
			(response) => {
				return checkStatus(response)
			}
		).then(
			(res) => {
				return checkCode(res)
			}
		)
	},
	fetchPost(url, data) {
		return axios({
			method: 'post',
			baseURL: '/',
			url,
			dataType:'json',
			data: data,
			timeout: 100000,
			headers: {
			    'X-Requested-With': 'XMLHttpRequest',
			    "Content-Type": "application/x-www-form-urlencoded",
			},
		}).then(
			(response) => {
				return checkStatus(response)
			}
		).then(
			(res) => {
				return checkCode(res)
			}
		)
	},
	get(url, params) {
		return axios({
			method: 'get',
			baseURL: '/',
			url,
			params, // get 请求时带的参数
			timeout: 100000,
			headers: {
			    'X-Requested-With': 'XMLHttpRequest',
			    "Content-Type": "application/json",
			},
		}).then(
			(response) => {
				return checkStatus(response)
			}
		).then(
			(res) => {
				return checkCode(res)
			}
		)
	},
}
